import React from 'react'

import Frequency from './Frequency'

const OpNTA = ({ details, clone }) => {
  const prefix = clone ? 'copy_' : ''

  if (!details[`${prefix}nta_active`]) {
    return null
  }

  return (
    <div className="setting-section">
      <div className="section-name">
        Negative Target Automation
      </div>
      <div className="setting-wrapper">
        Add ASINs (Products) as negatives:
        <span className="setting-value">
          { details[`${prefix}nta_negate_asins_active`] ? 'On' : 'Off' }
        </span>
      </div>
      <div className="setting-wrapper">
        Add to campaign level:
        <span className="setting-value">
          { details[`${prefix}nta_add_to_campaigns`] ? 'On' : 'Off' }
        </span>
      </div>
      <div className="setting-wrapper">
        Add to Ad Group level:
        <span className="setting-value">
          { details[`${prefix}nta_add_to_adgroups`] ? 'On' : 'Off' }
        </span>
      </div>
      {
        details[`${prefix}nta_clicks_active`] && (
          <div className="setting-wrapper">
            Click(s) without sale:
            <span className="setting-value">
              { details[`${prefix}nta_clicks`] }
            </span>
          </div>
        )
      }
      {
        details[`${prefix}nta_impressions_active`] && (
          <div className="setting-wrapper">
            Impressions without a click:
            <span className="setting-value">
              { details[`${prefix}nta_impressions`] }
            </span>
          </div>
        )
      }
      {
        details[`${prefix}nta_cost_active`] && (
          <div className="setting-wrapper">
            Ad spend without sale:
            <span className="setting-value">
              { details[`${prefix}nta_cost`] }
            </span>
          </div>
        )
      }
      {
        details[`${prefix}nta_ctr_greater_active`] && (
          <div className="setting-wrapper">
            CTR greater than:
            <span className="setting-value">
              { details[`${prefix}nta_ctr_greater`] }
            </span>
          </div>
        )
      }
      {
        details[`${prefix}nta_ctr_active`] && (
          <div className="setting-wrapper">
            CTR lower than:
            <span className="setting-value">
              { details[`${prefix}nta_ctr`] }
            </span>
          </div>
        )
      }
      <div className="setting-wrapper">
        Frequency:
        <span className="setting-value">
          <Frequency details={details} prefix={`${prefix}nta_`} />
        </span>
      </div>
      <div className="setting-wrapper">
        Lookback Period (days):
        <span className="setting-value">
          { details[`${prefix}nta_lookback`] }
        </span>
      </div>
    </div>
  )
}

export default OpNTA
